import { useBcCustomersQuery, useCompanyMutation, useCompanyQuery } from '@features/redux/apis/org';
import { useAlert } from '@hooks/useAlert';
import { MutationEffect } from '@helpers/MutationEffect';
import { Operation } from '@/types/general';
import { useQuery } from '@hooks/useQuery';
import { QueryEffect } from '@helpers/QueryEffect';

export const CompanyEffects = () => {
    const companyId = useQuery().get('id');
    const operation = companyId ? Operation.Edit : Operation.Create;

    const customersQueryState = useBcCustomersQuery({});
    const companyQueryState = useCompanyQuery({ companyId: +companyId! }, { skip: operation === Operation.Create });

    const [, mutationState] = useCompanyMutation({
        // We don't want to use the mutation cache if we're creating a new reseller
        fixedCacheKey: operation === Operation.Edit ? 'CompanyMutation' : 'CompanyCreation',
    });

    const { setAlert } = useAlert();

    return (
        <>
            <MutationEffect
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-expect-error
                mutationState={mutationState}
                effects={{
                    isError: () => {
                        setAlert(`Failed to ${operation} Company`, 'error');
                        mutationState.reset();
                    },
                    isSuccess: () => {
                        setAlert('Company Saved.', 'success');
                        mutationState.reset();
                        mutationState.reset();
                    },
                }}
            />

            <QueryEffect
                queryState={companyQueryState}
                effects={{
                    isError: () => {
                        setAlert('Failed to Load Company Data', 'error');
                    },
                }}
            />

            <QueryEffect
                queryState={customersQueryState}
                effects={{
                    isError: () => {
                        setAlert('Failed to load customer list', 'error');
                    },
                }}
            />
        </>
    );
};
